export default "__VITE_ASSET__DwvnKGY___"